import { DefaultType } from './ExpositionLevel.types';

export const ExpositionLevelEnum: DefaultType[] = [
	{ id: '', value: 'Seleccione' },
	{ id: 'low', value: 'Bajo' },
	{ id: 'medium', value: 'Moderado' },
	{ id: 'high', value: 'Alto' },
];

export const ExpositionLevelBadgeEnum: DefaultType[] = [
	{ id: 'low', value: 'Riesgo bajo', color: '#8DC63F' },
	{ id: 'medium', value: 'Riesgo moderado', color: '#F08B2D' },
	{ id: 'high', value: 'Riesgo alto', color: '#C22A58' },
];

export const ExpositionFrequencyEnum: DefaultType[] = [
	{ id: '', value: 'Seleccione' },
	{ id: 'lessFrequency', value: 'Poco frecuente' },
	{ id: 'frequent', value: 'Frecuente' },
	{ id: 'highFrequency', value: 'Muy frecuente' },
];
